<template>
  <el-select
    v-model="status"
    placeholder="เลือกสถานะ"
    :disabled="disabled"
    clearable
  >
    <el-option
      v-for="item in statusList"
      :key="item.value"
      :label="item.label"
      :value="item.value"
    ></el-option>
  </el-select>
</template>

<script>
import { Option as ElOption, Select as ElSelect } from "element-ui";
import { SellAndRentStatus } from "../SellAndRentStatus";

export default {
  components: {
    ElOption,
    ElSelect
  },
  props: {
    value: {
      type: String
    },
    disabled: {
      type: Boolean
    },
    hideItem: {
      type: Function
    }
  },
  data() {
    return {};
  },
  computed: {
    status: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    },
    statusList() {
      return Object.keys(SellAndRentStatus)
        .map(value => ({
          value,
          label: SellAndRentStatus[value]
        }))
        .filter(item => {
          return !this.hideItem || !this.hideItem(item.value);
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/features/sell-and-rent/components/SellAndRentStatusSelect.vue